import React, { useEffect, useState } from "react";

import { apiUrl } from "../../config";
import { FormSectionElements } from "../../entities/formTemplateDataType";
import { getViewportSize } from "../../utilities/HtmlUtils";

export type PlateImageProps = {
	field: FormSectionElements;
	plateType: string;
	sloganChoice: string;
	graphicChoice: string;
	showImage: boolean;
	redraw: boolean;
	setRedraw: (draw: boolean) => void
}

/**
 * A component to render the plate image.
 */
const PlateImageComponent = ({field, plateType, sloganChoice, graphicChoice, showImage, redraw, setRedraw}: PlateImageProps) => {
	const [draw, setDraw] = useState(false);
	const imgDomain = apiUrl();

	useEffect(() => {
		if (redraw && showImage && field.Valid && field.Value) {
			redrawLicencePlate();
			setRedraw(false);
		} 
	}, [redraw]);

	const redrawLicencePlate = (): void => {
		const fontType = new FontFace("AN-16-037", "url(" + imgDomain + "/assets/fonts/AN-16-037.woff2)", {
			style: "normal",
			weight: "400",
			stretch: "condensed",
		});
		document.fonts.add(fontType);
		fontType.load()  // Has to wait till the font is loaded before redrawing the plate-image.
			.then(() => {
				redrawElements();
				setRedraw(false);
			})
			.catch(err => {
				console.log('Error loading font AN-16-037');
			})
	}

	const redrawElements = () => {
		if (!showImage) {
			return;
		}

    const viewPortSize = getViewportSize();
    const mediaBreakpoint = 440;
		// <div id={`plate-image_${field.Id}`} style={{ position: 'relative', width: '400px', height: '200px' }}>
		const divElement = document.createElement('div');
		divElement.id = `plate-image_${field.Id}`;
		const divElementStyle = {
			position: 'relative',
      width: viewPortSize.width < mediaBreakpoint ? '300px' : '400px', 
      height: viewPortSize.width < mediaBreakpoint ? '150px' : '200px'
		};
    Object.assign(divElement.style, divElementStyle);

		// <img src={url}	alt="License Plate Background" style={{ width: '100%', height: '100%' }}/>
		const imgElement = document.createElement('img');
		divElement.appendChild(imgElement);
		const url = `${imgDomain}/assets/images/${plateType}_${sloganChoice}_${graphicChoice}.png`;
		imgElement.src = url;
		imgElement.alt = 'License Plate Background';
		const imgElementStyle = {
			width: viewPortSize.width < mediaBreakpoint ? '80%' : '100%',
      height: viewPortSize.width < mediaBreakpoint ? '80%' : '100%'
		};
    Object.assign(imgElement.style, imgElementStyle);
		const SVG_NS = "http://www.w3.org/2000/svg";

		// <svg viewBox="0 0 400 200" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
		const svgElement = document.createElementNS(SVG_NS, 'svg');
		divElement.appendChild(svgElement);
 		svgElement.setAttribute("viewBox", viewPortSize.width < mediaBreakpoint ? "0 0 350 175" : "0 0 400 200");
		const svgElementStyle = {
			position: 'absolute',
			top: 0, left: 0, 
      width: viewPortSize.width < mediaBreakpoint ? '87.5%' : '100%', 
      height: viewPortSize.width < mediaBreakpoint ? '87.5%' : '100%'
		};
    Object.assign(svgElement.style, svgElementStyle);

		// <text x="200" y="145" textAnchor="middle" fontSize="110" fill="#0080C0" fontFamily="AN-16-037" font-weight="bold">
		//   (plate-characters)
		// </text>
		const textElement = document.createElementNS(SVG_NS, "text");
		svgElement.appendChild(textElement);
		if (!graphicChoice || graphicChoice === '0000') {
			textElement.setAttributeNS(null, "x", viewPortSize.width < mediaBreakpoint ? "160" : "200"); // X-coordinate
		} else {
			textElement.setAttributeNS(null, "x", viewPortSize.width < mediaBreakpoint ? "200" : "245"); // X-coordinate
		}
		textElement.setAttributeNS(null, "y", viewPortSize.width < mediaBreakpoint ? "110" : "140"); // Y-coordinate
		textElement.setAttributeNS(null, "text-anchor", "middle"); // Center alignment
		textElement.setAttributeNS(null, "font-size", viewPortSize.width < mediaBreakpoint ? "88" : "105");
		textElement.setAttributeNS(null, "fill", "#0080C0");
		textElement.setAttributeNS(null, "font-family", "AN-16-037");
		textElement.setAttributeNS(null, "font-weight", "bold");
		textElement.textContent = field.Value?.toUpperCase();

		const plateContainer = document.getElementById(`container_plate-image_${field.Id}`);
		const previousDivContainer = document.getElementById(`plate-image_${field.Id}`);
		if (previousDivContainer) {  // Remove the previous <div>
			previousDivContainer.remove();
		}
		plateContainer.appendChild(divElement);
	}

	return (
		<div id={`container_plate-image_${field.Id}`}/>
	);
}

export default PlateImageComponent;